"use client";

import {
  prepareStudyPageSchedule,
  completeStudyPageSchedule,
} from "./server-actions/studyPlanActions";
import {
  toggleAttendance,
  incrementReview,
  type ToggleAttendanceResult,
} from "./server-actions/attendanceRecordActions";
import type { StudyTaskLink } from "./study-task-link";
import type { StudyPageScheduleResult } from "./study-page-schedule";

/** 완료할 항목은 출석 전에 고정한다. 일정 재시도 때 다음 항목을 고르지 않는다. */
export async function recordStudyPage(
  slug: string,
  codeLang: string,
  mode: "attendance" | "review",
  link: StudyTaskLink | null,
): Promise<ToggleAttendanceResult & { schedule?: StudyPageScheduleResult }> {
  const preparation = link
    ? null
    : await prepareStudyPageSchedule(slug, codeLang);
  if (preparation && !preparation.success)
    return { success: false, error: preparation.error };
  const prepared = preparation?.success ? preparation.prepared : null;
  const result = await (mode === "review" ? incrementReview : toggleAttendance)(
    slug,
    codeLang,
    link?.examSessionId ?? prepared?.examSessionId,
  );
  if (!result.success || !result.attended || !prepared) return result;
  if (!prepared.automatic)
    return {
      ...result,
      schedule: prepared.future.length
        ? { kind: "future", choices: prepared.future }
        : { kind: "none" },
    };
  // 출석은 이미 저장됐다. 일정 저장 실패로 출석/회독을 재시도하지 않게 별도 결과를 보낸다.
  try {
    const completed = await completeStudyPageSchedule(
      prepared.automatic,
      slug,
      true,
    );
    return {
      ...result,
      schedule: completed.success
        ? { kind: "completed", task: prepared.automatic }
        : {
            kind: "error",
            error: completed.error,
            retryTask: prepared.automatic,
          },
    };
  } catch {
    return {
      ...result,
      schedule: {
        kind: "error",
        error: "출석은 저장했지만 일정 연결에 실패했어요.",
        retryTask: prepared.automatic,
      },
    };
  }
}
